<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">{{ this.campaignId !== null ? "Update Campaign" : "Create Campaign" }}</h1>
                <div class="Options">
                    <button @click.stop="close">Close</button>
                </div>
            </div>
            <div class="modalBody">
                <h2 style="margin: 0px 0px;">Campaign Details</h2>
                <table>
                    <tbody>
                        <tr>
                            <td width="150">Campaign Name</td>
                            <td><input type="text" v-model="campaignData.campaignName" :disabled="checkCampaignUsed === true" maxlength="25" /></td>
                        </tr>
                        <tr>
                            <td>Single or multiple use code</td>
                            <td>
                                <label>
                                    <input type="radio" id="singleUse" value="true" v-model="campaignData.isSingleUsed" :disabled="checkCampaignUsed === true" />
                                    Single
                                </label>
                                <label>
                                    <input type="radio" id="multipleUse" value="false" v-model="campaignData.isSingleUsed" :disabled="checkCampaignUsed === true" />
                                    Multiple
                                </label>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h2 style="margin-bottom: 0px;">Code Type</h2>
                <table>
                    <tr>
                        <td width="150">Free Trial</td>
                        <td>
                            <label>
                                <input type="radio" id="TrialYes" value="true" v-model="campaignData.isFreeTrial" :disabled="checkCampaignUsed === true" />
                                Yes
                            </label>
                            <label>
                                <input type="radio" id="TrialNo" value="false" v-model="campaignData.isFreeTrial" :disabled="checkCampaignUsed === true" />
                                No
                            </label>
                        </td>
                    </tr>
                    <tr>
                        <td>License discount</td>
                        <td>
                            <label>
                                <input type="radio" id="LicenseYes" value="true" v-model="campaignData.isLicenseDiscount" :disabled="checkCampaignUsed === true || (campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '')" />
                                Yes
                            </label>
                            <label>
                                <input type="radio" id="LicenseNo" value="false" v-model="campaignData.isLicenseDiscount" :disabled="checkCampaignUsed === true || (campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '')" />
                                No
                            </label>
                        </td>
                    </tr>
                </table>

                <br />
                <hr />

                <h2 style="margin-bottom: 0px;">Free trial details</h2>
                <table>
                    <tr>
                        <td width="150">Trial Days</td>
                        <td><input type="number" min="0" v-model="campaignData.trialDays" :disabled="disableFreeTrialFields || checkCampaignUsed === true" /></td>
                    </tr>
                    <tr>
                        <td>Requires card</td>
                        <td>
                            <label>
                                <input type="radio" id="cardRequiredYes" value="true" v-model="campaignData.isCardRequired" :disabled="disableFreeTrialFields || checkCampaignUsed === true" />
                                Yes
                            </label>
                            <label>
                                <input type="radio" id="cardRequiredNo" value="false" v-model="campaignData.isCardRequired" :disabled="disableFreeTrialFields || checkCampaignUsed === true" />
                                No
                            </label>
                        </td>
                    </tr>
                </table>

                <div v-if="!checkCampaignUsed">
                    <button @click="saveOrUpdateCampaigns" class="large-button">{{ this.campaignId !== null ? "Update" : "Save" }}</button>
                </div>

                <h2 v-if="showCouponDetails || campaignId !== null" style="margin-top: 30px; margin-bottom: 0px;">Stripe coupon details</h2>
                <table v-if="showCouponDetails || campaignId !== null">
                    <tr>
                        <td width="150">Name</td>
                        <td><label>{{ campaignData.campaignName }}</label></td>
                    </tr>
                    <tr>
                        <td>Type</td>
                        <td>
                            <label>
                                <input type="radio" value="percentage" v-model="selectedType" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields"> Percentage discount
                            </label>
                            <label>
                                <input type="radio" value="fixedAmount" v-model="selectedType" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields"> Fixed amount discount
                            </label>
                        </td>
                    </tr>
                    <tr v-if="selectedType === 'percentage'">
                        <td>Percentage off</td>
                        <td>
                            <input class="input-with-margin" type="number" min="0" max="100" v-model="campaignData.discount" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields" />
                            <span>%</span>
                        </td>
                    </tr>
                    <tr v-else-if="selectedType === 'fixedAmount'">
                        <td>Discount amount</td>
                        <td>
                            <input type="number" min="0" max="100" v-model="campaignData.amountDiscount" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields" />
                        </td>
                    </tr>
                    <tr>
                        <td>Duration</td>
                        <td>
                            <select v-model="campaignData.duration" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields">
                                <option value="forever">Forever</option>
                                <option value="once">Once</option>
                                <option value="repeating">Multiple Months</option>
                            </select>
                        </td>
                    </tr>
                    <tr v-if="campaignData.duration === 'repeating'">
                        <td>Number of Months</td>
                        <td>
                            <input class="input-with-margin" type="number" id="monthDuration" v-model="campaignData.monthDuration" min="1" :max="12" step="1" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields">
                            <span>months</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Coupon expiry date</td>
                        <td>
                            <input type="datetime-local" v-model="campaignData.expiredDate" :disabled="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' || disableCouponFields" />
                        </td>
                    </tr>
                    <tr v-if="!isCouponCreated && (campaignData.stripeCouponId == null || campaignData.stripeCouponId == '')">
                        <td></td>
                        <td class="Options">
                            <button @click="createCoupon" :disabled="disableCouponFields">Create Coupon</button>
                        </td>
                    </tr>
                    <tr v-if="campaignData.stripeCouponId !== null && campaignData.stripeCouponId !== '' && !checkCampaignUsed">
                        <td></td>
                        <td class="Options">
                            <button class="destructive" @click="deleteCampaignInStripe(campaignId)">Delete Coupon</button>
                        </td>
                    </tr>
                </table>

                <div class="noteTextForUsedCode" v-if="checkCampaignUsed">
                    <label><i>Note: Coupon is already in use and cannot be deleted.</i></label>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .large-button {
        padding: 10px 20px;
        font-size: 16px;
        margin-left: 180px;
    }

    .noteTextForUsedCode {
        padding: 10px;
        color: red;
        text-align: center;
        font-weight: 700;
    }

    input[type=radio] {
        display: inline-block !important;
        margin-right: 5px;
    }

    label {
        display: inline-block;
        margin-right: 15px;
    }

    .destructive {
        background: #bc2525;
    }

    table td.Options button {
        float: left;
    }

    .input-with-margin {
        margin-right: 10px;
    }
</style>

<script>
    import $ from 'jquery';

    export default {
        name: 'AddEditCampaign',
        components: {
        },
        data: function () {
            return {
                campaignData: {
                    campaignName: '',
                    trialDays: '',
                    isCardRequired: false,
                    isSingleUsed: false,
                    amountDiscount: 0,
                    discount: 0,
                    expiredDate: '',
                    stripeCouponId: '',
                    currency: 'gbp',
                    duration: 'forever',
                    isFreeTrial: 'true',
                    isLicenseDiscount: 'true',
                    monthDuration: '',
                },
                selectedType: 'percentage',
                showCouponDetails: false,
                isCouponCreated: false,
                checkCampaignUsed: false
            }
        },
        props: {
            campaignId: Number
        },
        created: function () {
            this.getCampaignByID(this.campaignId);

            if (this.campaignId !== null)
                this.checkCampaignCodeUsed(this.campaignId);
        },
        computed: {
            disableFreeTrialFields() {
                return (this.campaignData.isFreeTrial.toString() === 'false');
            },
            disableCouponFields() {
                return (this.campaignData.isLicenseDiscount.toString() === 'false');
            }
        },
        methods: {
            displayDate: function (d) {
                if (d === null)
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            close() {
                this.$emit('close-modal');
            },
            getCampaignByID: function (id) {
                if (id !== null && id !== 0) {
                    var myComponent = this;
                    myComponent.loading = true;
                    $.ajax({
                        type: 'GET',
                        url: `/Campaign/GetCampaignsByID?id=${id}`,
                        dataType: 'json',
                        success: data => {
                            myComponent.campaignData = data || {};
                            if (data !== null)
                                myComponent.campaignData.duration = data.duration === '' ? 'forever' : data.duration;
                        },
                        error: () => {
                            alert('Failed to fetch campaign data.');
                        },
                        complete: function () {
                            myComponent.loading = false;
                        },
                    });
                }
            },
            saveOrUpdateCampaigns: function () {
                var myComponent = this;
                if (!myComponent.campaignData.campaignName) {
                    alert('Campaign Name is required');
                    return;
                }

                var isFreeTrial = (myComponent.campaignData.isFreeTrial.toString() === 'true');
                var isLicenseDiscount = (myComponent.campaignData.isLicenseDiscount.toString() === 'true');

                if (isFreeTrial &&
                    (myComponent.campaignData.trialDays === null || myComponent.campaignData.trialDays === '' || myComponent.campaignData.trialDays <= 0)) {
                    alert('Trial days are required when Free Trial is selected');
                    return;
                }
                else if (isFreeTrial === false && isLicenseDiscount === false) {
                    alert('Free Trial and License Discount cannot both be set to No.');
                    return;
                }

                const campaignData = {
                    campaignName: this.campaignData.campaignName,
                    trialDays: this.campaignData.trialDays,
                    isCardRequired: this.campaignData.isCardRequired,
                    isSingleUsed: this.campaignData.isSingleUsed,
                    isFreeTrial: this.campaignData.isFreeTrial,
                    isLicenseDiscount: this.campaignData.isLicenseDiscount,
                }

                const url = myComponent.campaignId !== null ? `/Campaign/SaveOrUpdateCampaign?id=${myComponent.campaignId}` : `/Campaign/SaveOrUpdateCampaign`;
                const requestData = {
                    id: myComponent.campaignId,
                    campaign: campaignData
                };

                $.ajax({
                    type: 'POST',
                    url: url,
                    contentType: 'application/json',
                    data: JSON.stringify(requestData),
                    success: (data) => {
                        if (data !== null) {
                            if (data.message === "Campaign saved/updated successfully.") {
                                myComponent.showCouponDetails = true;
                                myComponent.$emit('campaign-id-updated', data.id);
                                alert(data.message);
                            } else {
                                alert(data.message);
                            }
                        } else {
                            alert('Failed to save/update campaign. Please try again.');
                        }
                    },
                    error: (xhr) => {
                        if (xhr.responseJSON && xhr.responseJSON.detail) {
                            alert(xhr.responseJSON.detail);
                        } else {
                            if (xhr.status === 400) {
                                alert(xhr.responseText);
                            } else if (xhr.status === 400) {
                                alert('An error occurred while saving/updating the campaign. Please try again.');
                            } else {
                                alert("An error occurred while updating coupon");
                            }
                        }
                    },
                });

                if (myComponent.campaignData.isLicenseDiscount === 'false') {
                    this.campaignData.isLicenseDiscount = false;
                    this.$nextTick(() => {
                        this.showCouponDetails = false;
                        this.showCouponDetails = true;
                    });
                }
            },
            createCoupon() {
                if (this.selectedType === 'percentage') {
                    if (this.campaignData.discount === null || isNaN(this.campaignData.discount) || this.campaignData.discount <= 0) {
                        alert('Please enter a valid percentage discount.');
                        return;
                    }
                }

                if (this.selectedType === 'fixedAmount') {
                    if (this.campaignData.amountDiscount === null || isNaN(this.campaignData.amountDiscount) || this.campaignData.amountDiscount <= 0) {
                        alert('Please enter a valid fixed amount discount.');
                        return;
                    }
                }

                if (this.campaignData.duration === 'repeating') {
                    if (this.campaignData.monthDuration === null || isNaN(this.campaignData.monthDuration) || this.campaignData.monthDuration <= 0) {
                        alert('Please enter a valid number of months greater than zero for the multiple months duration.');
                        return;
                    }
                }

                var confirmMessage = 'Are you sure you want to save the campaign? You can not update it.';
                if (!confirm(confirmMessage))
                    return;

                const convertedAmountDiscount = Math.round(this.campaignData.amountDiscount * 100);

                const requestData = {
                    id: this.campaignId,
                    campaignName: this.campaignData.campaignName,
                    discount: this.selectedType === 'percentage' ? this.campaignData.discount : null,
                    amountDiscount: this.selectedType === 'fixedAmount' ? convertedAmountDiscount : null,
                    currency: this.selectedType === 'fixedAmount' ? 'gbp' : '',
                    expiredDate: this.campaignData.expiredDate,
                    duration: this.campaignData.duration,
                    monthDuration: this.campaignData.duration === 'repeating' ? this.campaignData.monthDuration : null,
                };

                $.ajax({
                    type: 'POST',
                    url: `/Campaign/CreateCoupon`,
                    contentType: 'application/json',
                    data: JSON.stringify(requestData),
                    success: (response) => {
                        if (response === "Coupon created successfully") {
                            this.isCouponCreated = true;
                            this.campaignData.stripeCouponId = response;
                            alert("Coupon created successfully");
                        } else {
                            alert("Coupon creation failed");
                        }
                    },
                    error: (xhr, error) => {
                        if (xhr.status === 400) {
                            alert(xhr.responseText);
                        } else if (xhr.status === 500) {
                            alert('An internal server error occurred.');
                        } else {
                            alert('Error occurred while creating coupon:', error);
                        }
                    }
                });
            },
            deleteCampaignInStripe(id) {
                var vm = this;
                if (confirm("Are you sure you want to delete this campaign?")) {
                    $.ajax({
                        type: 'DELETE',
                        url: `/Campaign/DeleteCampaignInStripe/${id}`,
                        success: function (response) {
                            alert(response);
                            vm.campaignData.stripeCouponId = '';
                            vm.campaignData.expiredDate = '';
                            vm.campaignData.currency = '';
                            vm.campaignData.duration = 'forever';
                            vm.campaignData.amountDiscount = 0;
                            vm.campaignData.discount = 0;
                            vm.campaignData.monthDuration = 0;
                            vm.isCouponCreated = false;
                            vm.showCouponDetails = false;
                        },
                        error: function (xhr) {
                            if (xhr.status === 404)
                                alert("Campaign code not found.");
                            else if (xhr.status === 500)
                                alert("An internal server error occurred.");
                            else
                                alert('Error deleting campaign code:', + xhr.responseText);
                        }
                    });
                }
            },
            checkCampaignCodeUsed(id) {
                var vm = this;
                $.ajax({
                    url: `/Campaign/CheckCampaignCodeUsed/${id}`,
                    type: 'GET',
                    success: function (data) {
                        vm.checkCampaignUsed = data;
                    },
                    error: function () {
                        alert("Error occurred while checking campaign code usage");
                    }
                });
            }
        },
        watch: {
            'campaignData.discount'(newVal) {
                if (newVal !== null && newVal !== 0) {
                    this.selectedType = 'percentage';
                }
            },
            'campaignData.amountDiscount'(newVal) {
                if (newVal !== null && newVal !== 0) {
                    this.selectedType = 'fixedAmount';
                }
            },
            'selectedType'(newVal) {
                if (newVal === 'fixedAmount')
                    this.campaignData.discount = 0;
                else if (newVal === 'percentage')
                    this.campaignData.amountDiscount = 0;
            },
            'campaignData.stripeCouponId'(newVal) {
                this.showCouponDetails = newVal !== null && newVal !== '';
            },
        }
    };
</script>